import React from 'react';
import { Text } from 'src/components/text/Text';
import { useLocale } from 'src/hooks/use-locale';
import { type InstallmentOffer } from 'src/types/widget-offers';

import { Icon } from '../../../../../icon';
import styles from './SubventionOffer.css';

type Props = {
  offer: InstallmentOffer;
};

export const SubventionOffer = ({ offer }: Props) => {
  const t = useLocale();

  return (
    <div className={styles.SubventionOffer}>
      <div className={styles.SubventionOffer__Content}>
        <div className={styles.SubventionOffer__DealIcon}>
          <Icon name="deal" />
        </div>
        <Text as="p" variant="body2Tight">
          {t(
            'pay_in_x_interest_free_payments_on_eligible_items',
            { paymentsCount: offer.paymentsCount },
            {
              b: (string) => (
                <Text as="strong" variant="body2TightBold">
                  {string}
                </Text>
              ),
            }
          )}
        </Text>
      </div>
      <div className={styles.SubventionOffer__ArrowIcon}>
        <Icon name="arrow" />
      </div>
    </div>
  );
};
